import { render, staticRenderFns } from "./WebsiteForm.vue?vue&type=template&id=b2e66bda&scoped=true"
import script from "./WebsiteForm.vue?vue&type=script&lang=js"
export * from "./WebsiteForm.vue?vue&type=script&lang=js"
import style0 from "./WebsiteForm.vue?vue&type=style&index=0&id=b2e66bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e66bda",
  null
  
)

export default component.exports